
import StageManager from "../../../../../shared/lib/html5-software-library/src/ranj/performance/StageManager";
import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import { applySearchParametersToObject, getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AssetLibrary from "../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import SaveEvent from "../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import PuzzleGenerator from "../controller/PuzzleGenerator";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
import GameElementSkinFactory from "../view/GameElementSkinFactory";

export default class InitAccuracyGameTask extends Task {

    /**
     * @param {AssetLibrary} assetLibrary 
     * @param {GameConfig} gameConfig 
     * @param {GameModel} gameModel 
     * @param {StageManager} stageManager
     */
    constructor(dispatcher, assetLibrary, gameConfig, gameModel, levelAssets, stageManager) {
        super();

        this.execute = function(callback, progressCallback) {

            if (AppModel.isMobile) {
                stageManager.setAllStagesFramerate(30);
            }

            var configJSON = assetLibrary.getAsset("gameConfig");
            if (ranj.DEBUG) {
                applySearchParametersToObject(window.top.location.search, configJSON);
                window.document.addEventListener("keyup", this._handleKeyUp);
            }
            gameConfig.setPropertiesFromObject(configJSON);

            gameModel.initialize();
            const lvl = parseInt(getURLParameter("level"));
            if (!isNaN(lvl)) {
                gameModel._puzzleIndex = Math.max(lvl - 2, -1);
            }

            if (ranj.DEBUG) {
                window.gameconfig = gameConfig;
                window.gamemodel = gameModel;

                const n = parseInt(getURLParameter("generate"));
                if (!isNaN(n)) {
                    const elementFactory = new GameElementSkinFactory(gameConfig, levelAssets);
                    const puzzles = PuzzleGenerator.generate(gameConfig, elementFactory, n);
                    console.log(JSON.stringify(puzzles));
                    gameConfig._data.puzzles = puzzles;
                }
            }

            callback(this);
        }

        this._handleKeyUp = function(e) {
            const c = String.fromCharCode(e.which);
            if (c == "R") {
                if (confirm("Are you sure you want to reset the savegame?")) {
                    dispatcher.dispatch(SaveEvent.CLEAR);
                    window.location.reload();
                }
            }
        }.bind(this);


        document.addEventListener("visibilitychange", _ => {
            console.log("Event: visibilitychange. Hidden: " + document.hidden);
            createjs.Ticker.paused = document.hidden;
        });
    }




}
